import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d24ee84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-password-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["edit-password-root", { 'is-not-ipad': !_ctx.isIpadProDevice }]),
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('settings.changepassword')), 1),
        _createVNode(_component_icon_x, {
          class: "close",
          onClickPassive: _ctx.close
        }, null, 8, ["onClickPassive"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          action: "",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('settings.oldpwd')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldpassword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.oldpassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('settings.newpwd')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newpassword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newpassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('settings.confirmnewpwd')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmpassword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.confirmpassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.message), 1)
        ], 32),
        _createElementVNode("div", {
          class: "confirm",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, _toDisplayString(_ctx.t('common.confirm')), 1)
      ])
    ])
  ], 2))
}